import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCustomerAuth } from '../contexts/CustomerAuthContext';

const ProtectedCustomerRoute = ({ children }) => {
    const { customer, loading } = useCustomerAuth();
    const location = useLocation();

    if (loading) {
        return <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading...</div>;
    }

    if (!customer) {
        return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedCustomerRoute;
